import { Loader2 } from "lucide-react";

import type { RdoStatus } from "@/adapters/api";
import { Badge } from "@/components/ui/badge";
import { RDO_STATUS } from "../../utils/status.ts";

export function RdoStatusBadge({ status }: { status: RdoStatus }) {
	const presentation = RDO_STATUS[status];
	return (
		<Badge
			variant={presentation.variant}
			className="rdo-status-badge"
			data-status={status}
		>
			{status === "generating" ? (
				<Loader2 className="rdo-status-badge__spinner" aria-hidden />
			) : (
				<span aria-hidden className="rdo-status-badge__dot" />
			)}
			{presentation.label}
		</Badge>
	);
}
